import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import RequestAccessModal from '../components/RequestAccessModal';
import styles from './SignInPage.module.css';

const SignInPage = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [isRequestAccessModalOpen, setIsRequestAccessModalOpen] = useState(false);
  const { login, loading, error } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(formData.email, formData.password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      // password field should clear on failure
      setFormData((prev) => ({ ...prev, password: '' }));
    }
  };

  const handleRequestAccess = () => {
    setIsRequestAccessModalOpen(true);
  };

  const closeRequestAccessModal = () => {
    setIsRequestAccessModalOpen(false);
  };

  return (
    <div className={styles.signinPage}>
      <div className={styles.signinContainer}>
        <div className={styles.logoContainer}>
          <img src="/podee.png" alt="Podee" className={styles.logo} />
        </div>
        <form onSubmit={handleSubmit} className={styles.signinForm}>
          <div className={styles.formGroup}>
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              autoComplete="email"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck="false"
              placeholder="Enter your email"
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              autoComplete="current-password"
              placeholder="Enter your password"
            />
          </div>
          {error && <div className={styles.errorMessage}>{error}</div>}
          <div className={styles.buttonWrapper}>
            <button type="submit" disabled={loading} className="btn btn-primary">
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </div>
        </form>
        <p className={styles.signupLink}>
          Don't have an account? <button 
            type="button" 
            onClick={handleRequestAccess}
            className={styles.requestAccessLink}
          >
            Request Access
          </button>
        </p>
      </div>
      
      <RequestAccessModal 
        isOpen={isRequestAccessModalOpen}
        onClose={closeRequestAccessModal}
      />
    </div>
  );
};

export default SignInPage;
